const focus = {
  mounted(el, binding) {
    // 1. 找到需要聚焦的元素。
    // 优先查找 Element Plus/UI 的原生 <input> 或 <textarea> 子元素
    let focusableElement = el.querySelector('input, textarea')

    // 如果找不到子输入框，则使用指令绑定的根元素本身。
    // 这适用于原生的 <input>、<button>、<a> 等元素，以及其他非 el-input 的可聚焦元素。
    if (!focusableElement) {
      focusableElement = el
    }

    // 2. 执行聚焦逻辑。
    const shouldFocus = binding.value !== false // 默认聚焦，除非明确传入 v-focus="false"

    if (shouldFocus) {
      // 检查元素是否具有 focus 方法（即它是可聚焦的）
      if (typeof focusableElement.focus === 'function') {
        // 使用 setTimeout 确保在 DOM 完全渲染和组件初始化完成后执行聚焦
        setTimeout(() => {
          focusableElement.focus()
        }, 300)
      } else {
        // console.warn('v-focus 指令：尝试聚焦的元素不具备 .focus() 方法。', focusableElement);
      }
    }
  },
  updated(el, binding) {
    // 仅在值从 false 变为 true 时重新尝试聚焦
    if (binding.value === true && binding.oldValue === false) {
      const focusableElement = el.querySelector('input, textarea') || el

      if (typeof focusableElement.focus === 'function') {
        setTimeout(() => {
          focusableElement.focus()
        }, 300)
      }
    }
  }
};

export default focus;